import { render } from "./ProdutosTable.vue?vue&type=template&id=2a83db2c"
import script from "./ProdutosTable.vue?vue&type=script&lang=js"
export * from "./ProdutosTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__